import { useIsFetching } from "@tanstack/react-query";

export function useInitialIsFetching() {
  const isInitialFetching = useIsFetching({
    predicate: (query) => query.state.status === "pending",
  });
  return isInitialFetching > 0;
}
